export const menus = [
    {
        title: 'voucherOfPayment',
        pathName: 'payroll',
        icon: 'library_books'
    },
    {
        title: 'novelty',
        pathName: 'novelty',
        icon: 'dvr'
    },
    {
        title: 'laborCertificate',
        pathName: 'labor-letter',
        icon: 'folder_shared'
    },
    {
        title: 'uploadCurriculum',
        pathName: 'upload',
        icon: 'file_upload'
    },
    {
        title: 'retentionCertificate',
        pathName: 'retention-certificate',
        icon: 'receipt'
    },
    {
        title: 'myData',
        pathName: 'person',
        icon: 'assignment_ind'
    },
    {
        title: 'familyGroup',
        pathName: 'FamilyGroupIndex',
        icon: 'wc'
    },
    // {
    //     title: 'news',
    //     pathName: 'news',
    //     icon: 'library_books'
    // },
    {
        title: 'logout',
        pathName: 'logout',
        icon: 'power_settings_new'
    }
]
